import React from 'react'
import './header.scss'

const Header = ({ children }) => <div className="yo-header">{children}</div>

export default Header
